import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "@/assets/css/common.less";
import VueLazyload from "vue-lazyload";

Vue.config.productionTip = false;

Vue.use(VueLazyload, {
    preLoad: 1.3,
});

new Vue({
    router,
    store,
    render: (h) => h(App),
}).$mount("#app");
